(function (ws) {
    'use strict';
    ws.views.submittedRMAlistingTable = ws.views.simpleTable.extend({

        /**
         * Initialize override
         */
        initialize: function () {
            this.$table = this.$('#submitted-RMA-table');
            this.paginateUrl = globals.path.api.westcon.submittedrmaTablePaginateUrl;
            this.searchUrl = globals.path.api.westcon.submittedrmaTableSearchUrl;
            this.overrideFilterRequest = true;
            this.rowTemplate = this.$('#submitted-rma-listing-table-row');
            this.$orderbByCriteria = this.$('#tbl-simple-orderby');
            this.$startDateInput = this.$('#tbl-simple-start-date');
            this.$endDateInput = this.$('#tbl-simple-end-date');
            this.$searchInput = this.$('.tbl-simple-searchInput');
            this.multiViewEnabled = this.$('#multiViewEnabled').val();

            this.controlColumn = 0;

            ws.views.simpleTable.prototype.initialize.call(this);

            //Making the select dropdowns without scroll and without search textbox
            $('.tbl-simple-filters select').select2({
                minimumResultsForSearch: Infinity,
                dropdownAutoWidth: true,
                dropdownCssClass: 'comp-order-table'
            });

            this.searchFilterCall();
            this.serialNoLength = this.$('.serialNoLength');
            this.searchType = this.$('#searchType');
            this.placeholderMsg = this.$('.placeholderMsg');
        },

        /**
         * Events override
         */
        events: _.extend({}, ws.views.simpleTable.prototype.events, {
            'change #tbl-simple-orderby': 'searchFilter',
            'keypress .tbl-simple-searchInput': 'searchFunction',
            'change input#tbl-simple-start-date': 'validateDate',
            'change input#tbl-simple-end-date': 'validateDate',
            'keydown input#tbl-simple-end-date': 'validateDate',
            'keydown input#tbl-simple-start-date': 'validateDate',
            'focusout input#tbl-simple-end-date': 'validateDate',
            'focusout input#tbl-simple-start-date': 'validateDate',
            'change select#tbl-simple-page-size': 'searchFilterStatus',
            'click .tbl-magnifying': 'triggerSearch',
            'click .requestAnRMA': 'handleRequestRMA'
        }),

        /**
         * Override filter request object
         * @param {Object} request
         */
        customFilterRequest: function (request) {
            return _.extend({}, request, {
                orderedBy: this.$orderbByCriteria.val()
            });
        },

        /**
         * Handle Request RMA event and tracking Analytic event
         */
        handleRequestRMA (e) {
            e.preventDefault();
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION);
            window.location.href = $(e.currentTarget).attr('href');
        },

        /**
         * Trigger Search
         */
        triggerSearch: function () {
            var e = $.Event('keypress', {which: 13});
            this.$searchInput.trigger(e);
        },

        /**
         * Call Search Filter API
         * Overriding from the parent view
         * @param {Object} request
         */
        searchFilterCall: function (request) {
            this.model.set(request);
            this.model.url = this.searchUrl;
            this.$table.dataTable().fnClearTable();
            this.$table.dataTable().fnDestroy();
            this.$table.DataTable().destroy();

            this.$tableSpinner.show();
            this.$emtpyTableCopy.hide();

            $.each(this.$tableHeaders, function (i, th) {
                $(th).removeClass('loaded');
            });

            // calling without arguments to hide pagination
            this.calculateShowing();
            this.calculatePagination();
            this.enableDelaySpinner();

            this.model.save().done(function (data) {
                this.$tableSpinner.hide();
                this.disabledDelaySpinner();
                this.renderRows(data.data);
                this.calculateShowing(data.paginationData);
                this.calculatePagination(data.paginationData);
                this.$pagination.addClass('search');
                if (request) {
                    this.$clearFilterButton.toggle(this.showClearFilterButton);
                    if (this.showClearFilterButton) {
                        this.$('.message-link').hide();
                    }
                }

                this.toggleApplySearchBtn(true);
            }.bind(this)).fail(function () {
                this.tableGenericError();
                this.disabledDelaySpinner();
            }.bind(this));
        },

        /**
         * Overiding the Render a table row from the parent
         * @param {Object} result
         */
        renderRows: function (result) {
            var options;
            var _this = this;
            _.each(result, function (row) {
                row.multiViewEnabled = _this.multiViewEnabled;

                options = {
                    model: row,
                    rowTemplate: _this.rowTemplate
                };
                var tableRow = new ws.views.simpleTableRows(options);
                _this.$table.append(tableRow.render().el);
            });

            this.fadeInRows();
            this.initializeDataTable();

            if (this.sortColumn) {
                this.$table.find('th[data-attr=' + this.sortColumn + ']').addClass('sorting_' + this.sortCode);
            }
        },

        // Search Function
        searchFunction: function (e) {
            let serialNoLength = this.serialNoLength.html();
            if (e.which === 13) {
                e.preventDefault();
                if (e.target.value) {
                    if (this.$searchInput.val().length < parseInt(serialNoLength) && this.searchType.val() === 'serialNumber') {
                        this.placeholderMsg.show();
                    } else {
                        this.placeholderMsg.hide();
                        this.search(e);
                    }
                }
            }
        },

        /**
         * default filter
         */
        setDefaultDateFilter: function () {
            var $endDate = new Date();
            var $startDate = new Date();
            $startDate.setDate($startDate.getDate() - 90);
            this.$endDateInput.val(moment($endDate).format('MM/DD/YY'));
            this.$startDateInput.val(moment($startDate).format('MM/DD/YY'));
        },

        // Validate Date
        validateDate: function (e, makeApiCall = true) {
            // if pressing enter key, prevent refresh (since some tables are forms)
            //e may not be defined if date changed happens from pikaday

            let serialNoLength = this.serialNoLength.html();
            if (e && (e.keyCode === 13 || e.which === 13)) {
                e.preventDefault();
            }

            if (this.$searchInput.val().length < parseInt(serialNoLength) && this.searchType.val() === 'serialNumber') {
                this.placeholderMsg.show();
            } else {
                this.placeholderMsg.hide();
                var beginningDate = this.$startDateInput.val();
                var endDate = this.$endDateInput.val();
                var beginDateValid = globals.validateDate(beginningDate);
                var endDateValid = globals.validateDate(endDate);

                //remove error classes
                this.$startDateInput.removeClass('error');
                this.$endDateInput.removeClass('error');
                this.$dateError.hide();
                this.$validDateError.hide();
                this.$searcherrors.hide();

                //show start date error
                if (beginDateValid === false) {
                    this.$startDateInput.addClass('error');
                    this.$dateError.show();
                }

                //show end date error
                if (endDateValid === false) {
                    this.$endDateInput.addClass('error');
                    this.$dateError.show();
                }

                //check for start date is less than end date
                var validCheck = '';
                if (endDateValid && beginDateValid) {
                    validCheck = globals.compareDates(beginningDate, endDate);
                    if (!validCheck) {
                        this.$validDateError.show();
                    }
                }

                //if no errors and either enter key pressed, or change made from pikaday, make api call
                if (beginDateValid === true && endDateValid === true && validCheck === true && ((e.keyCode === 13 || e.which === 13) || (e === 'pikaday')) && makeApiCall) {
                    var gaEventLabel = beginningDate + ',' + endDate + '_date_range';
                    this.searchFilter(e, undefined, gaEventLabel);
                }
            }
        },

        searchFilterStatus: function (e = undefined, page = undefined, gaEventLabel = undefined) {
            let serialNoLength = this.serialNoLength.html();
            if (this.$searchInput.val().length < parseInt(serialNoLength) && this.searchType.val() === 'serialNumber') {
                this.placeholderMsg.show();
            } else {
                this.placeholderMsg.hide();
                this.$searcherrors.hide();
                this.$apiErrors.hide();
                var searchProperty = this.searchType.val();
                var searchText = this.$searchInput.val();
                var statusText = this.$statusInput.val() === this.$statusInput.data('placeholder') ? '' : this.$statusInput.val();
                var sourceText = this.$sourceInput.val() === this.$sourceInput.data('placeholder') ? '' : this.$sourceInput.val();
                var amText = this.$amInput.val();
                var quoteNumber = !_.isUndefined(this.$quoteNumber) ? this.$quoteNumber.val() : '';
                var copyQuoteOption = !_.isUndefined(this.$copyQuoteOption) ? this.$copyQuoteOption.val() : '';
                var beginningDate = this.$startDateInput.val();
                var endDate = this.$endDateInput.val();
                var startDueDate = this.$startDueDateInput.val();
                var endDueDate = this.$endDueDateInput.val();
                var lowerPriceLimit = parseFloat(this.$priceInputLower.val());
                var upperPriceLimit = parseFloat(this.$priceInputUpper.val());
                var pageSize = this.$pageSizeInput.val();
                var selectedSalesOrg = !_.isUndefined(this.$salesOrgValue.val()) ? this.$salesOrgValue.val() : this.$salesOrg.val();
                this.error = false;

                //don't show clear filter button if changing page size
                this.showClearFilterButton = e && $(e.currentTarget).attr('id') !== 'tbl-simple-page-size' && !page || this.$clearFilterButton.is(':visible');

                var request = {
                    amFilter: amText,
                    searchText: searchText,
                    searchProperty: searchProperty,
                    quoteCloseFromDate: startDueDate,
                    quoteCloseToDate: endDueDate,
                    fromDate: beginningDate,
                    toDate: endDate,
                    lowPrice: lowerPriceLimit,
                    highPrice: upperPriceLimit,
                    sortCode: this.sortColumn,
                    order: this.sortCode,
                    sortType: this.sortCode,
                    salesOrg: selectedSalesOrg,
                    page: page, //failing on search rfq by price
                    pageSize: pageSize,
                    status: statusText,
                    source: sourceText,
                    type: sourceText,
                    quoteNum: quoteNumber,
                    copyQuoteOption: copyQuoteOption,
                    paginationData: '', //makes sure this is not an object, otherwise BE error
                    data: ''
                };

                // update request object if filters for table are not the usual search criteria, input field, date, price range ones
                if (this.overrideFilterRequest === true) {
                    request = this.customFilterRequest(request);
                }

                /**
                 * Checking the store site and handling event tracking for Google Analytics
                 * GTM_EVENT_CATEGORY and GTM_EVENT_ACTION inherited from accountquotetable view
                 *
                 */
                if (isEcomSite) {
                    if (e && $(e.currentTarget).attr('id') === 'tbl-simple-select') {
                        this.gtmEventTracking(this.GTM_EVENT_CATEGORY, 'filter_quote', 'status_' + $(e.currentTarget).val());
                    } else if (e && $(e.currentTarget).attr('class') === 'tbl-simple-searchInput') {
                        this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION, this.gtmFilterOptions[searchProperty]);
                    } else if (gaEventLabel) {
                        this.gtmEventTracking(this.GTM_EVENT_CATEGORY, 'filter_quote', gaEventLabel);
                    }
                }

                if (location.href.indexOf('store') > -1) {

                    dataLayerAA.search = {};
                    dataLayerAA.search.type = this.searchCategory;
                    dataLayerAA.search.field = searchProperty;
                    dataLayerAA.search.query = searchText;

                    if ($('#pageName').val() === 'orderlistingpage')
                        dataLayerAA.search.status = statusText;

                    _satellite.track('event:search');
                }

                this.searchFilterCall(request);
                this.handleClearSearch(request);
            }
        }
    });
})(westcon);

